import { useThree } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
// import { OrbitControls } from "three/addons/controls/OrbitControls.js";

// extend({ OrbitControls });

const Control = ({ isFree, box, target }) => {
    // console.log("isFree START: ", isFree);
    // const {
    //     camera,
    //     gl: { domElement },
    // } = useThree();

    const { camera } = useThree();
    // console.log("camera: ", camera);

    // useEffect(() => {
    //     window.addEventListener("keydown", moveCamera);
    //     return () => window.removeEventListener("keydown", moveCamera);
    // }, []);

    // const moveCamera = (event) => {
    //     console.log("event: ", event.code);
    //     if (event.code === "ArrowUp") {
    //         camera.position.y += 0.1;
    //     }
    //     if (event.code === "ArrowDown") {
    //         camera.translateY(-0.1);
    //     }
    //     if (event.code === "ArrowLeft") {
    //         camera.translateX(0.1);
    //     }
    //     if (event.code === "ArrowRight") {
    //         camera.translateY(0.1);
    //     }
    // };
    // const controls = useRef();

    const checkCamera = () => {
        // console.log("isFree: ", isFree);
        if (!isFree) {
            if (camera.position.x > box[0]) camera.position.x = box[0];
            if (camera.position.x < box[1]) camera.position.x = box[1];
            if (camera.position.y > box[2]) camera.position.y = box[2];
            if (camera.position.y < box[3]) camera.position.y = box[3];
            if (camera.position.z > box[4]) camera.position.z = box[4];
            if (camera.position.z < box[5]) camera.position.z = box[5];
        }
    };

    // const controls = new OrbitControls(camera, domElement);
    // controls.listenToKeyEvents(window);
    // // controls.keys = { LEFT: 37, UP: "KeyW", RIGHT: "KeyD", BOTTOM: "KeyS" };
    // controls.keyPanSpeed = 20;
    // controls.addEventListener("change", checkCamera);
    // controls.update();

    // useFrame((state) => controls.update());

    return (
        <OrbitControls
            enableDamping={false}
            makeDefault
            enableZoom={isFree}
            onChange={checkCamera}
            target={[target[0] - 0.2, target[1], target[2]]}
            // args={[camera, domElement]}
            // ref={controls}
        />
    );
};

export default Control;
